import styled from "styled-components";
import { Row, Col, Grid } from "antd";
import { RATypography } from "@/components/customs";
import { PATH_PUBLIC_IMAGES } from "@/config/images";
import { RAImage } from "@/components/customs";

import { IconClockSolutionsSvg, IconMissionCriticalSpeedSvg } from "@/assets/images";
const { useBreakpoint } = Grid;

const SERVICES_STEP = {
	FIRST: "FIRST",
	SECOND: "SECOND",
};

export function ServiceAFIntroduction({ royal_air_freight = {} }) {
	const screens = useBreakpoint();
	return (
		<div
			style={{
				width: "100vw",
				display: "flex",
				flexDirection: "column",
				justifyContent: "center",
				alignItems: "center",
				padding: "20px 0",
			}}
		>
			<Row justify="center" style={{ maxWidth: 1442, width: "100%" }}>
				<Col span={16}>
					<RATypography variant={screens?.md ? "h2" : "h4"} align="center">
						{royal_air_freight?.title || ""}
					</RATypography>
				</Col>
			</Row>
			<Row justify="center" style={{ maxWidth: 1442, width: "100%" }}>
				<Col span={18}>
					<RATypography variant="p" align="center" top="20px" maxLines={4}>
						{royal_air_freight?.sub_title || ""}
					</RATypography>
				</Col>
			</Row>
		</div>
	);
}

export function ServiceEachRoyalAirFreight({ royal_air_freight = {}, step = SERVICES_STEP.FIRST }) {
	const renderTItle = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return royal_air_freight?.hight_light1?.title;
			case SERVICES_STEP.SECOND:
				return royal_air_freight?.hight_light2?.title;
			default:
				return "";
		}
	};

	const renderDescription = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return royal_air_freight?.hight_light1?.description;
			case SERVICES_STEP.SECOND:
				return royal_air_freight?.hight_light2?.description;
			default:
				return "";
		}
	};

	const renderPhoto = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return royal_air_freight?.hight_light1?.photo;
			case SERVICES_STEP.SECOND:
				return royal_air_freight?.hight_light2?.photo;
			default:
				return PATH_PUBLIC_IMAGES.service_af_freight_1;
		}
	};

	const renderIconContent = () => {
		switch (step) {
			case SERVICES_STEP.FIRST:
				return <RAImage url={IconMissionCriticalSpeedSvg} width={44} height={44} />;
			case SERVICES_STEP.SECOND:
				return <RAImage url={IconClockSolutionsSvg} width={44} height={44} />;
			default:
				return "";
		}
	};

	return (
		<EachRowContainer>
			<EachRow
				justify="center"
				align="middle"
				style={{
					paddingTop: 20,
					paddingBottom: 20,
					animationDuration: "0.3s",
				}}
				gutter={[20, 0]}
			>
				<CardSectionItem
					name={renderTItle()}
					description={renderDescription()}
					image={renderPhoto()}
					icon={renderIconContent()}
				/>
			</EachRow>
		</EachRowContainer>
	);
}

const CardSectionItem = ({ name = "", description = "", image, icon }) => {
	const screens = useBreakpoint();
	return (
		<WrapperItem gutter={[0, 20]} align="middle">
			<Col
				sm={{
					span: 12,
					order: 2,
				}}
				xs={{
					span: 24,
					order: 1,
				}}
				style={{
					paddingRight: screens?.xs ? "0" : "40px",
					paddingLeft: screens?.xs ? "0" : "0",
				}}
			>
				<RAImage
					url={image}
					width="100%"
					height={screens?.xl ? "360px" : screens?.lg ? "320px" : "210px"}
					borderRadius="12px"
				/>
			</Col>
			<Col
				sm={{
					span: 12,
					order: 2,
				}}
				xs={{
					span: 24,
					order: 2,
				}}
			>
				<div>
					{icon}
					<RATypography variant="sub-heading2" top="16px">
						{name}
					</RATypography>
					<RATypography variant="body3" top="10px" color="#595959">
						{description}
					</RATypography>
				</div>
			</Col>
		</WrapperItem>
	);
};

const EachRowContainer = styled.div`
	width: 100%;
	max-width: 1442px;
	display: flex;
	/* padding-top: 160px; */
	flex-direction: column;
	justify-content: flex-end;
	align-items: flex-start;
	position: ${({ snap }) => (snap === "true" ? "absolute" : "static")};
	.center {
		width: 208px;
		height: 52px;
	}
	.btn {
		width: 208px;
		height: 52px;
		border-radius: 50px;
		cursor: pointer;
		background: transparent;
		border: 1px solid #ffb11a;
		outline: none;
		transition: 2s ease-in-out;
		box-sizing: border-box;
		position: relative;
	}
	.btn:hover {
		transition: 2s ease-in-out;
	}
	.btn:hover svg {
		stroke-dashoffset: -480;
	}
	.btn span {
		color: #222222;
		font-family: "DM Sans";
		font-weight: 500;
		font-size: 14px;
		letter-spacing: 3px;
		text-transform: uppercase;
		text-indent: 3px;
	}
`;
const EachRow = styled(Row)`
	margin: 50px 0;
	@media (max-width: 797px) {
		margin: 32px 0;
	}
	@media (max-width: 575px) {
		margin: 16px 0;
	}
`;
const WrapperItem = styled(Row)`
	width: 100%;
	height: 100%;
`;
